"use client";

import { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { WagmiProvider } from "wagmi";
import { arbitrum, arbitrumSepolia } from "wagmi/chains";
import {
  RainbowKitProvider,
  getDefaultConfig,
  darkTheme,
} from "@rainbow-me/rainbowkit";
import { GoogleOAuthProvider } from "@react-oauth/google";
import {
  metaMaskWallet,
  injectedWallet,
  walletConnectWallet,
  rainbowWallet,
  trustWallet,
  zerionWallet,
  okxWallet,
  ledgerWallet,
  phantomWallet,
  rabbyWallet,
} from "@rainbow-me/rainbowkit/wallets";
import "@rainbow-me/rainbowkit/styles.css";
import { WalletTracker } from "@/components/WalletTracker";
import { WalletOnboardingModal } from "@/components/WalletOnboardingModal";

const projectId = process.env.NEXT_PUBLIC_WALLETCONNECT_ID ?? "";

const wallets = projectId ? [
  {
    groupName: "Popular",
    wallets: [metaMaskWallet, walletConnectWallet, rainbowWallet],
  },
  {
    groupName: "More",
    wallets: [injectedWallet, trustWallet, zerionWallet, okxWallet, ledgerWallet, phantomWallet, rabbyWallet],
  },
] : [
  { groupName: "Wallets", wallets: [metaMaskWallet, injectedWallet] },
];

const appUrl = process.env.NEXT_PUBLIC_APP_URL ?? "https://blackdoor.claims";

const wagmiConfig = getDefaultConfig({
  appName:   "BlackDoor",
  projectId: projectId || "00000000000000000000000000000000",
  appUrl,
  wallets,
  chains: [arbitrum, arbitrumSepolia],
  ssr:    true,
});

const queryClient = new QueryClient();
const googleClientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? "";

export function Providers({ children }: { children: ReactNode }) {
  return (
    <GoogleOAuthProvider clientId={googleClientId}>
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          theme={darkTheme({
            accentColor:           "#ffffff",
            accentColorForeground: "#000000",
            borderRadius:          "large",
          })}
        >
          <WalletTracker />
          <WalletOnboardingModal />
          {children}
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
    </GoogleOAuthProvider>
  );
}
